(function () {
  function initSnow() {
    // Create canvas
    const canvas = document.createElement("canvas");
    canvas.id = "snow-canvas";
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");

    // Canvas dimensions
    let w = canvas.width = window.innerWidth;
    let h = canvas.height = window.innerHeight;

    // Snowflake symbols
    const snowChars = ["❄", "❅", "❆"];

    // Create flakes
    let flakes = [];
    const numFlakes = 150; // Adjust for density
    for (let i = 0; i < numFlakes; i++) {
// Create flakes
    flakes.push({
    x: Math.random() * w,
    y: Math.random() * h,
    r: Math.random() * 1.5 + 1, // smaller max
    d: Math.random() * 0.5 + 0.2, // speed between 0.2 and 0.7

    });


    }

    // Draw snow
    function draw() {
      ctx.clearRect(0, 0, w, h);

      flakes.forEach(f => {
        //ctx.font = `${f.r * 6}px Arial`;
        // In draw():
        ctx.font = `${f.r * 4}px Arial`; // smaller font size

        ctx.fillStyle = "rgba(255,255,255,0.9)";
        ctx.fillText(
          snowChars[Math.floor(Math.random() * snowChars.length)],
          f.x,
          f.y
        );

        // Move flakes
        f.y += f.d;
        f.x += Math.sin(f.y * 0.01);

        // Reset when offscreen
        if (f.y > h) {
          f.y = -10;
          f.x = Math.random() * w;
        }
      });

      requestAnimationFrame(draw);
    }

    draw();

    // Canvas style
    canvas.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      pointer-events: none;
      z-index: 9999;
      width: 100%;
      height: 100%;
    `;

    // Resize handler
    window.addEventListener("resize", () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    });
  }

  // DOM ready guard
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSnow);
  } else {
    initSnow();
  }
})();
